<template>
  <div class="rt-picklist">
    <el-select
      v-model="selectedValue"
      :disabled="disabled"
      clearable
      @change="handleChange"
    >
      <el-option
        v-for="item in options"
        :key="item[valueKey]"
        :label="item[nameKey]"
        :value="item[valueKey]"
        >{{ item[nameKey] }}</el-option
      >
    </el-select>
    <rt-icon slot="suffix" name="rt-base-dropdown" />
  </div>
</template>

<script type="text/javascript">
const DEFAULT_KEYS = {
  value: 'Value',
  name: 'Text'
};
export default {
  name: 'RtPicklist',
  props: {
    fetch: {
      type: Function,
      default: null,
      required: false
    },
    value: {
      type: [String, Number],
      default: ''
    },
    params: {
      type: Object,
      default: null
    },
    entity: {
      type: String
    },
    attribute: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    alias: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      selectedValue: null,
      options: []
    };
  },
  computed: {
    valueKey() {
      return this.alias.value || DEFAULT_KEYS.value;
    },
    nameKey() {
      return this.alias.name || DEFAULT_KEYS.name;
    }
  },
  watch: {
    value(newVal, oldVal) {
      this.selectedValue = newVal;
    }
  },
  mounted() {
    this.bindPicklist();
  },
  methods: {
    bindPicklist() {
      if (this.fetch) {
        this.fetch()
          .then(res => {
            this.options = res;
          })
          .catch(error => {
            rt.showErrorToast(error.message);
          });
      } else {
        let { params, entity, attribute } = this;
        params = Object.assign({}, params, { entity, attribute });
        this.$picklist
          .getPicklistData(params)
          .then(res => {
            this.options = res;
          })
          .catch(error => {
            rt.showErrorToast(error.message);
          });
      }
      if (this.value) {
        this.selectedValue = this.value;
      }
    },
    handleChange(val) {
      this.$emit('input', val);

      this.$emit('change', val);
    }
  }
};
</script>

<style lang="less">
.rt-picklist {
  position: relative;
  display: flex;
  align-items: center;
  .rt-icon {
    position: absolute;
    right: 0;
    color: #dbe0f3;
  }
  .el-select {
    width: 100%;
    .el-input.is-focus .el-input__inner,
    .el-input__inner:focus,
    .el-input__inner:hover {
      border-color: #ecf0f7;
    }
    .el-input__prefix,
    .el-input__suffix {
      display: none;
    }
    .el-input__inner {
      padding: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?bcee543e